import { SVGProps } from 'react';

const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 644.88 584.52"
    {...props}
  >
    <defs>
      <style>{'.cls-1{fill:currentColor}'}</style>
    </defs>
    <path
      className="cls-1"
      d="M425.59 1.35c7.28-.98 15.62-.56 22.52 1.97 50.01 31.08 105.95 58.6 154.64 91.36 13.16 8.86 22.8 19.1 24.12 35.88 4.7 59.79-3.63 125.65 0 186.07-1.57 13.7-8.77 25.26-19.71 33.29l-154 92c-10.67 5.01-23.49 5.85-34.59 1.96-50.08-31.26-106.56-58.76-155.25-91.75-12.88-8.73-22.23-19.11-23.51-35.49-4.7-59.79 3.63-125.65 0-186.07 1.57-13.7 8.77-25.26 19.71-33.29L413.51 5.27c3.67-1.46 8.19-3.4 12.08-3.92m-32.76 69.73 125.68 74.86 40.3-24.34-124.7-75.35zM347.48 97.3l-39.63 24.29 125.48 75.44 40.48-24.44zm-63.65 214.79 126.02 75.51 1.98-1.01v-149l-128-77.5zm299 0v-152l-128 77.5v149l1.98 1.01zm-408.21 53.3c81.01-6.01 140.54 75.3 109.97 150.97-36.47 90.29-165.06 91-202.94 1.41-29.2-69.08 18.52-146.85 92.97-152.38m1.97 74.96c-42.31 5.8-36.39 74.85 10.64 69.63 45.04-5 38.96-76.43-10.64-69.63M197.83.09l5 361.01c-15.3-1.39-30.84-1.88-46 .99l-4-316c-7.49.19-15.05-.23-22.55-.04-32.29.83-64.59.75-97 1-3.67.03-6.4 1.26-10.84.92-29.88-2.3-28.93-42.39-3.03-45.79 15.16-1.99 36.88.22 52.96-.04C106.84 1.56 141.83.97 176.29.05c7.17-.19 14.39.23 21.55.04Z"
    />
    <path
      className="cls-1"
      d="M293.83 518.09c4.31-15.01 7.05-30.28 5.99-46 16.83-.24 33.71.32 50.55.05 80.88-1.31 162.05-1.99 242.92-3.08 9.93-.13 29.54-1.47 37.93 2.15 21.74 9.39 16.37 41.43-7.9 43.88-69.63-.54-139.45 1.58-208.94 2.06-40.17.28-80.48-1.05-120.54.95Z"
    />
  </svg>
);
export default SVGComponent;
